import { useState } from 'react';

import { CupIcon } from '@/assets/icons/CupIcon.tsx';
import { CompetitionWinnersDialog } from '@/components/CompetitionWinnersDialog/index.ts';
import { CompetitionWinnersList } from '@/components/CompetitionWinnersList/index.ts';
import type { CompetitionWinner } from '@/lib/api/requests.ts';

import { Section } from '../_components/Section.tsx';

export const WinnersSection = (props: { allWinners: CompetitionWinner[] | undefined }) => {
  const [open, setOpen] = useState(false);

  if (!props.allWinners) {
    return null;
  }

  return (
    <Section>
      <div className="flex flex-col items-center">
        <CupIcon sx={{ mb: 2, mx: 'auto' }} />
        <h2 className="mx-auto mb-12 max-w-[30ch] typography-v1-h1 text-balance">
          Vinnere fra tidligere trekninger
        </h2>
        <div className="mx-auto w-full max-w-4xl">
          <CompetitionWinnersList winners={props.allWinners.slice(0, 10)} />
        </div>

        <button className="mx-auto mt-4 text-center text-[#18A0FB]" onClick={() => setOpen(true)}>
          Vis alle ({props.allWinners.length})
        </button>
      </div>
      <CompetitionWinnersDialog
        open={open}
        onClose={() => setOpen(false)}
        winners={props.allWinners}
      />
    </Section>
  );
};
